import React, { ReactElement } from 'react';
import { sessionApi } from '../../../../../../../../../../redux/views/session-view/session/api/api';
import { InternalIP } from '.';

export function ConnectedDCloudInternalIP({
  sessionUid,
  versionUid,
}: FetchSessionArgs): ReactElement {
  const { sessionInternalAddresses, isLoading, isFetching, isError } =
    sessionApi.endpoints.getSession.useQueryState(
      {
        sessionUid,
        versionUid,
      },
      {
        selectFromResult: ({ data, isLoading, isFetching, isError }) => ({
          isError,
          isFetching,
          isLoading,
          sessionInternalAddresses:
            data?.sessionDetails.sessionInternalAddresses,
        }),
      },
    );

  return (
    <InternalIP
      sessionInternalAddresses={sessionInternalAddresses}
      isLoading={isLoading || isFetching}
      isError={isError}
    />
  );
}
